module.exports = __webpack_public_path__ + "static/img/culture-success.3d3d8e50.png";